/* eslint-disable react/jsx-pascal-case */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import EventComment from "./EventComment";
import $ from "jquery";

import Event20201221_newContent from "./Event20201221_newContent";
import Event202104_newContent from "./Event202104_newContent";
import Event202105_open from "./Event202105_open";

class EventContent extends Component {
  state = {
    eventIdx: this.props.childProps.eventIdx,
  };
  componentDidMount = () => {
    window.addEventListener("resize", this._getWindowSize);
    //this._getWindowSize()
    this._getWindowSize();
  };
  _getWindowSize = () => {
    $("img[usemap]").rwdImageMaps();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
    window.removeEventListener("resize", this._getWindowSize);
  };

  _onClose = () => {
    const { setEventIdx } = this.props;
    setEventIdx(0);
  };
  _goView = () => {
    const { history, setEventIdx } = this.props;
    setEventIdx(0);
    history.push("/titan");
  };
  _goSns = (gubun) => {
    let url;
    if (gubun === "T") {
      url = "https://twitter.com/ANIPLUSTV/status/1343479280525737987";
    } else if (gubun === "F") {
      url = "https://www.facebook.com/aniplushd/posts/3553215288129136";
    } else {
      url = "https://www.youtube.com/post/Ugz41xKSabk9E_gY1NV4AaABCQ";
    }

    window.open(url, "", "");
  };
  render() {
    const { eventIdx, pos } = this.props.childProps;
    //API로 수정 할것.
    let bgImg, eventImg;

    //console.log(eventIdx, pos)

    if (parseInt(eventIdx) === 284) {
      bgImg = "/img/event/20201201/bg_1201.png";
      eventImg = "/img/event/20201201/img_1201.png";
    } else if (parseInt(eventIdx) === 285) {
      bgImg = "/img/event/20201218/bg.jpg";
      eventImg = "";
    } else if (parseInt(eventIdx) === 287) {
      bgImg = "/img/event/20210317/bg.png";
      eventImg = "";
    }
    return (
      <Fragment>
        <div
          className={pos === "pop" ? "detail_layer_pop_event" : null}
          style={{
            background: "url(" + bgImg + ") no-repeat top center",
            backgroundColor: "#000",
          }}
        >
          <div
            className="detail_view"
            style={
              pos === "pop" ? { overflowY: "scroll" } : { overflowY: "hidden" }
            }
          >
            {pos === "pop" ? (
              <div className="detail_layer_close" onClick={this._onClose}>
                <img src="/img/event/20200921/c.png" />
              </div>
            ) : null}

            <div
              className={
                parseInt(eventIdx) === 287 ? null : "detail_view_layer"
              }
            >
              {parseInt(eventIdx) === 284 ? (
                <Fragment>
                  <div className="detil_top" style={{ marginTop: -40 }}>
                    <div>
                      <img
                        src={eventImg}
                        style={{ width: "100%" }}
                        useMap="#Map1"
                      />{" "}
                    </div>
                  </div>
                  <map name="Map1">
                    <area
                      onClick={() => this._goSns("F")}
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="1, 974, 491, 1104"
                    />
                    <area
                      onClick={() => this._goSns("T")}
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="489, 976, 982, 1103"
                    />
                    <area
                      onClick={() => this._goSns("Y")}
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="982, 977, 1469, 1101"
                    />
                    <area
                      onClick={this._goView}
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="580, 1871, 899, 1962"
                    />
                  </map>
                </Fragment>
              ) : parseInt(eventIdx) === 285 ? (
                <Event20201221_newContent />
              ) : parseInt(eventIdx) === 287 ? (
                <Fragment>
                  <Event202104_newContent _onClose={this._onClose} />
                </Fragment>
              ) : parseInt(eventIdx) === 288 ? (
                <Event202105_open />
              ) : null}

              {/*덧글*/}
              <EventComment eventIdx={eventIdx} />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(EventContent));
